module.exports = __webpack_public_path__ + "media/images/color_admin_v3/product/product-4-2f12d35617537bb0b560aae6ed542d4b.png";